/* import __COLOCATED_TEMPLATE__ from './bandpass-multiplefeedback-noposfb.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();